import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CartContext = createContext();

export function CartProvider({ children }) {
  const [cartItems, setCartItems] = useState([]);
  const [cartOpen, setCartOpen] = useState(false);
  const [sessionId] = useState(() => {
    const stored = localStorage.getItem('bh_session');
    if (stored) return stored;
    const id = 'sess_' + Math.random().toString(36).substr(2, 9);
    localStorage.setItem('bh_session', id);
    return id;
  });

  const fetchCart = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/cart/${sessionId}`);
      setCartItems(res.data);
    } catch (e) { console.error(e); }
  }, [sessionId]);

  useEffect(() => { fetchCart(); }, [fetchCart]);

  const addToCart = async (packageId) => {
    try {
      await axios.post(`${API}/cart/add`, { session_id: sessionId, package_id: packageId });
      await fetchCart();
      setCartOpen(true);
    } catch (e) { console.error(e); }
  };

  const removeFromCart = async (packageId) => {
    try {
      await axios.delete(`${API}/cart/${sessionId}/${packageId}`);
      await fetchCart();
    } catch (e) { console.error(e); }
  };

  const cartTotal = cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0);
  const cartCount = cartItems.reduce((sum, item) => sum + item.quantity, 0);

  const getWhatsAppLink = () => {
    const phone = '919179992213';
    let msg = 'Hi! I would like to book the following packages from Beyond Horizons:\n\n';
    cartItems.forEach((item, i) => {
      msg += `${i + 1}. ${item.package_name} (${item.destination}) - ${item.duration} - Rs.${item.price.toLocaleString('en-IN')} x ${item.quantity}\n`;
    });
    msg += `\nTotal: Rs.${cartTotal.toLocaleString('en-IN')}\n\nPlease help me with the booking!`;
    return `https://wa.me/${phone}?text=${encodeURIComponent(msg)}`;
  };

  return (
    <CartContext.Provider value={{ cartItems, cartOpen, setCartOpen, addToCart, removeFromCart, cartTotal, cartCount, getWhatsAppLink }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
